module.exports = __webpack_public_path__ + "img/冷汗.4eac0838.gif";